import React from 'react';
import './Programs.css';

const Programs = () => {
  const Icons = {
    Computer: () => <svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>,
    Network: () => <svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="3"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"/></svg>,
    Briefcase: () => <svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>,
    Code: () => <svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>
  };

  const programData = [
    { 
      icon: <Icons.Computer />, 
      title: "Master of Computer Applications", 
      href: "/master-of-computer-applications-mca/",
      desc: "A two-year programme bridging core CS with AI, cloud computing, and cybersecurity to foster leadership and innovation." 
    },
    { 
      icon: <Icons.Network />, 
      title: "Integrated MCA",
      href: "/imca/",
      desc: "A 5-year program that combines the undergraduate and postgraduate curriculum into a streamlined and focused academic journey, eliminating the need for separate entrance procedures for a master's degree." 
    },
    { 
      icon: <Icons.Briefcase />, 
      title: "MCA for Working Professionals", 
      href: "/mca-working-professional/",
      desc: "A two-year postgraduate program for individuals looking to advance their career while continuing their employment." 
    },
    { 
      icon: <Icons.Code />, 
      title: "Ph.D. (Computer Application)",
      href: "/phd-admission/",
      desc: "A rigorous research-focused programme affiliated with the University of Mumbai, preparing scholars for leadership in academia and industry." 
    }
  ];

  return (
    <div className="am-page-root">
      <div className="am-main-content">
        <div className="rs5865f2-titleWrap">
          <div className="rs5865f2-titleRow">
            <div className="rs5865f2-titlePlain">Our</div>
            <div className="rs5865f2-titleGradient">Programs</div>
          </div>
          <div className="rs5865f2-gradientLine" />
        </div>

        <div className="am-feature-grid">
          {/* LEFT COLUMN - Left Aligned */}
          <div className="am-grid-col am-col-left">
            {programData.slice(0, 2).map((p, i) => (
              <a className="am-feature-item" href={p.href} key={i}>
                <div className="am-icon-box">{p.icon}</div>
                <div className="am-feature-heading">{p.title}</div>
                <div className="am-feature-desc">{p.desc}</div>
                <div className="am-divider"></div> 
              </a>
            ))}
          </div>

          {/* CENTER COLUMN - Robot Image/Video */}
          <div className="am-grid-col am-col-center">
            <div className="am-image-wrapper">
              <video src="/timscdr-web-robo-1.mp4" className="am-robot-image" autoPlay loop muted playsInline />
              <div className="am-blur-blob am-blob-top"></div>
              <div className="am-blur-blob am-blob-bottom"></div>
            </div>
          </div>

          {/* RIGHT COLUMN - Right Aligned */}
          <div className="am-grid-col am-col-right">
            {programData.slice(2, 4).map((p, i) => (
              <a className="am-feature-item am-item-right" href={p.href} key={i}>
                <div className="am-icon-box">{p.icon}</div>
                <div className="am-feature-heading">{p.title}</div>
                <div className="am-feature-desc">{p.desc}</div>
                {i === 0 && <div className="am-divider"></div>}
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Programs;
